/* @flow */
import React from 'react';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import BankAccountsManager from 'payments/components/BankAccountsManager.jsx';
import LinkedAccountsTable from 'payments/components/LinkedAccountsTable.jsx';
import PaymentCardsManager from 'payments/components/PaymentCardsManager.jsx';
import WalletTabSection from 'payments/components/WalletTabSection.jsx';
import TransactionsListContainer from 'payments/containers/TransactionsListContainer.jsx';
import Link from 'components/Link.jsx';
import Divider from 'components/Divider.jsx';

import {
  PendingBankAccountRequestNotification,
} from 'payments/components/ActivitiesNotification.jsx';

import './styles/TransactionSettings.scss';

type Props = {
  canCreateActivity: boolean,
  connectedBankAccounts: ConnectedBankAccount[],
  requestsForUnconfirmedEmail: boolean,
};

function TransactionSettings(props: Props) {
  const linkedAccounts = props.connectedBankAccounts
    .filter(account => account.getCanManage() && account.isApproved());

  const pendingAccounts = props.connectedBankAccounts
    .filter(account => account.getCanManage() && account.isPending());

  return (
    <div className="TransactionSettings">
      {props.canCreateActivity && (pendingAccounts.length > 0 || props.requestsForUnconfirmedEmail) &&
        <div>
          <WalletTabSection title="Pending deposit approval">
            {pendingAccounts.length > 0 &&
              <PendingBankAccountRequestNotification number={pendingAccounts.length} />
            }
            {props.requestsForUnconfirmedEmail &&
              <div className="TransactionSettings-message">
                There are pending deposit requests for your email. Please <Link to="/settings/notifications">confirm your email</Link> to manage them.
              </div>
            }
          </WalletTabSection>
          <Divider />
        </div>
      }

      {props.canCreateActivity && linkedAccounts.length > 0 &&
        <div>
          <WalletTabSection title="Deposit approval">
            <LinkedAccountsTable bankAccounts={linkedAccounts} />
          </WalletTabSection>
          <Divider />
        </div>
      }

      {props.canCreateActivity &&
        <div>
          <WalletTabSection title="Bank account">
            <BankAccountsManager />
          </WalletTabSection>
          <Divider />
        </div>
      }

      <WalletTabSection title="Credit & debit cards">
        <PaymentCardsManager />
      </WalletTabSection>

      <Divider />

      <WalletTabSection title="Transaction history">
        <TransactionsListContainer />
      </WalletTabSection>
    </div>
  );
}

export default TransactionSettings;



// WEBPACK FOOTER //
// ./src/settings/components/TransactionSettings.jsx